var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"width:100%"},[_c('span',{staticStyle:{"display":"none"}},[_vm._v(_vm._s(_vm.refresh))]),_c('canvas',{attrs:{"id":_vm.canvasId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }